module.exports = __webpack_public_path__ + "static/media/sticky.7cf74881.png";